import { qsParse } from 'Helpers/navigation';

export function getJWT(search: string): string | null {
	const queryParams = qsParse(search);
	return queryParams?.jwt as string | null;
}
